import { memo, useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SideMenu from "./sidemenu/sidemenu";
import { useSelector } from "react-redux";
import { CSSTransition } from "react-transition-group";
const Content = () => {
    const menuFadeLg = useSelector(state => state.theme.menuFadeLg);
    const [fadeAnim, setFadeAnim] = useState(false);
    const location = useLocation();

    useEffect(() => {
        setFadeAnim(true);
    }, [location.pathname])

    return (
        <>
            <SideMenu />

            <CSSTransition
                in={fadeAnim}
                timeout={100}
                onEntered={() => setFadeAnim(false)}
            >
                <main>
                    <div className={`p-content${menuFadeLg ? " lg-action" : ""}`}>
                        <Outlet />
                    </div>
                </main>
            </CSSTransition>
        </>
    )
}

export default memo(Content);